import { useTranslation } from 'react-i18next'


import { LoyaltyRegisterMessage } from '@entities/User'
import stylesMessage from '@entities/User/ui/profile/styles.module.scss'

import { useModalStore } from '@features/modal'


export default function useProfileCustomerModal () {
  const { openModal, closeModal } = useModalStore()
  const { t: tu } = useTranslation('user')

  const openProfileCustomerModal = (onCloseCallback?: () => void) => {
    openModal('profileCustomerInfo', <LoyaltyRegisterMessage />, {
      title: tu('loyaltyRegister.title'),
      classes: {
        content: stylesMessage['modal-content'],
      },
      onClose: () => {
        if (onCloseCallback) {
          onCloseCallback()
        }
      },
    })
  }
  const closeProfileCustomerModal = () => closeModal('profileCustomerInfo')

  return {
    openProfileCustomerModal,
    closeProfileCustomerModal,
  }
}
